import { render } from "./CreateCampaignsModal.vue?vue&type=template&id=67b73dce&scoped=true&ts=true"
import script from "./CreateCampaignsModal.vue?vue&type=script&lang=ts"
export * from "./CreateCampaignsModal.vue?vue&type=script&lang=ts"

import "./CreateCampaignsModal.vue?vue&type=style&index=0&id=67b73dce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b73dce"]])

export default __exports__